import { Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";

function SkeletonUI({
    columns = Array.from({ length: 6 }),
    rows = Array.from({ length: 10 }),
    componentStyleProps = {
        tableHeadSx: {},
        tableHeaderCellSx: {},
        tableBodySx: {},
        tableBodyCellSx: {},
        tableSx: {},
        tableContainerSx: {},
    },
    sx = {},
}) {
    return (
        <TableContainer
            component={Paper}
            sx={{
                ...componentStyleProps.tableContainerSx,
                ...sx,
            }}
        >
            <Table
                sx={{
                    minWidth: 650,
                    ...componentStyleProps.tableSx,
                }}
                aria-label="simple table"
            >
                <TableHead
                    sx={{
                        "&.MuiTableHead-root": {
                            backgroundColor: "background.paper",
                        },
                        "&.MuiTableHead-root .MuiTableCell-root": {
                            fontSize: "14px",
                            lineHeight: "18px",
                            fontWeight: 500,
                            textTransform: "inherit",
                        },

                        ...componentStyleProps.tableHeadSx,
                    }}
                >
                    <TableRow>
                        {columns.map((currentColumn, index) => (
                            <TableCell
                                key={index}
                                align="left"
                                sx={{
                                    "& .MuiButtonBase-root.MuiTableSortLabel-root": {
                                        visibility: "hidden",
                                    },
                                    "&:hover .MuiButtonBase-root.MuiTableSortLabel-root": {
                                        visibility: "visible",
                                    },
                                    ...componentStyleProps.tableHeaderCellSx,
                                }}
                                // {...currentColumn.headCellProps}
                            >
                                <Skeleton variant="text" sx={{ fontSize: "1.2rem", width: "75%" }} />
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody
                    sx={{
                        "&.MuiTableBody-root .MuiTableRow-root .MuiTableCell-root": {
                            borderBottom: "1px solid #E9E9E9",
                        },
                        "&.MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root": {
                            borderBottom: "none",
                        },
                        "&.MuiTableBody-root .MuiTableCell-root": {
                            fontSize: "14px",
                            lineHeight: "20px",
                            fontWeight: 400,
                            color: "#374566",
                        },

                        ...componentStyleProps.tableBodySx,
                    }}
                >
                    {rows?.length > 0 ? (
                        rows.map((row, index) => {
                            return (
                                <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                    {columns.map((cColumn, index) => {
                                        return (
                                            <TableCell key={index}>
                                                <Skeleton variant="text" sx={{ fontSize: "1rem", width: `${getRandomBetween()}%` }} />

                                                {/* {!cColumn?.hideCellValue && (typeof row[cColumn?.fieldName] !== "object" || Array.isArray(row[cColumn?.fieldName])) && row[cColumn?.fieldName]}{" "}
                                                {cColumn.renderElement && cColumn.renderElement(row, row[cColumn.fieldName])} */}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })
                    ) : (
                        <TableRow>
                            <TableCell
                                align="center"
                                colSpan={columns?.length}
                                sx={(theme) => ({
                                    background: theme.palette.background.paper,
                                    color: theme.palette.text.secondary,
                                    borderColor: theme.palette.gray[200],
                                    fontSize: "14px", // 14px
                                    fontWeight: theme.typography.fontWeightRegular,
                                    lineHeight: "150%",
                                })}
                            >
                                No Data
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

function getRandomBetween(start = 70, end = 90) {
    // Convert inputs to numbers
    start = Number(start);
    end = Number(end);

    // Validate inputs
    if (isNaN(start) || isNaN(end)) {
        console.error("Both start and end must be valid numbers.");
        return null;
    }

    if (start > end) {
        // Swap values if start is greater than end
        [start, end] = [end, start];
    }

    return Math.floor(Math.random() * (end - start + 1)) + start;
}

export default SkeletonUI;
